import { StyledPopover } from "./styles";

const Popover = ({trigger="click", 
    className, 
    arrow=false, 
    open, 
    children, 
    content, 
    ...rest}) =>{
    return(
        <StyledPopover 
        rootClassName={`${className} custom-popover-ant`} 
        arrow={arrow} 
        {...rest} 
        open={open} 
        trigger={trigger} 
        content={content}>
            {children && children}
        </StyledPopover>
    )
}
export default Popover;